import { render, staticRenderFns } from "./Persons.vue?vue&type=template&id=6b20e426&scoped=true&"
import script from "./Persons.vue?vue&type=script&lang=ts&"
export * from "./Persons.vue?vue&type=script&lang=ts&"
import style0 from "./Persons.vue?vue&type=style&index=0&id=6b20e426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b20e426",
  null
  
)

export default component.exports